import { useEffect, useMemo, useState } from 'react';
import { listGlobalTags } from 'services/Settings';
import { totalCountEvent } from 'services/generalServices';

export function useGlobalTagList(practiceAreaId = '', options = {}, loadFullList = true, limit = 10) {
  const [tagList, setTagList] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [globalTagsNextToken, setGlobalTagsNextToken] = useState('');

  const loadGlobalList = async (practiceAreaId = '') => {
    setisLoading(true);
    if (loadFullList) {
      totalCountEvent('global-tag')
        .then((response) => {
          listGlobalTags(response.data, '', '', '', practiceAreaId)
            .then((response) => {
              setTagList(response?.data?.global_tag);
            })
            .catch((error) => console.log(error))
            .finally(() => setisLoading(false));
        })
        .finally(() => setisLoading(false));
    } else {
      try {
        const response = await listGlobalTags(limit, '', '', '', practiceAreaId);
        setTagList(response?.data?.global_tag);
        setGlobalTagsNextToken(response?.data?.next_token || '');
        return response?.data;
      } catch (error) {
        console.log(error);
      } finally {
        setisLoading(false);
      }
    }
  };

  useEffect(() => {
    loadGlobalList(practiceAreaId);
  }, [practiceAreaId]);

  const formattedGlobalTag = useMemo(() => {
    if (tagList?.length > 0) {
      let tagsArray = [];
      tagList.forEach((item) => {
        tagsArray.push({ name: item.tag, value: item.tag });
      });
      return tagsArray;
    }
  }, [tagList]);

  return {
    globalList: tagList,
    formattedGlobalTag,
    loadGlobalList,
    isTagsLoading: isLoading,
    globalTagToken: globalTagsNextToken,
    setGlobalTagToken: setGlobalTagsNextToken,
  };
}
